import { Layout } from 'react-admin';
import CustomAppBar from './AppBar';

const CustomLayout = ({ children }) => {
  return <Layout appBar={CustomAppBar}>{children}</Layout>;
};

export default CustomLayout;
